// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55f530ac","455":"2bb02c60"}[chunkId] + ".chunk.js";
};